import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { CheckCircleIcon } from '@phosphor-icons/react';

import type { SiteGoal } from '@/components/org-settings/types';

const GOALS: { id: SiteGoal; title: string; description: string }[] = [
  { id: 'recruit', title: 'Recruit new families', description: 'Lead with why families should join — the join page and story come first.' },
  { id: 'serve', title: 'Serve current families', description: 'Lead with what happens next — the calendar and meeting info come first.' },
  { id: 'both', title: 'Both', description: 'A balanced homepage for both new and current families. The default, and easy to change later.' },
];

// Spec section 4, Step 2. Reversible — this is a starting point, not a
// lock (revisit anytime; today that just means re-running this step's
// choice manually, no dedicated settings UI for it yet).
export function GoalStep({ goal, onChangeGoal }: { goal: SiteGoal; onChangeGoal: (goal: SiteGoal) => void }) {
  return (
    <Stack spacing={2.5}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        What&apos;s this site mainly for?
      </Typography>
      <Typography color="text.secondary">You can change this anytime — it just picks a sensible starting layout.</Typography>

      <Stack spacing={1.5}>
        {GOALS.map((option) => {
          const selected = goal === option.id;
          return (
            <ButtonBase
              key={option.id}
              onClick={() => onChangeGoal(option.id)}
              sx={{
                textAlign: 'left',
                borderRadius: 2,
                border: '2px solid',
                borderColor: selected ? 'primary.main' : 'divider',
                p: 2,
              }}
            >
              <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', width: '100%' }}>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 700 }}>{option.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {option.description}
                  </Typography>
                </Box>
                {selected ? <CheckCircleIcon size={22} weight="fill" color="var(--mui-palette-primary-main)" /> : null}
              </Stack>
            </ButtonBase>
          );
        })}
      </Stack>
    </Stack>
  );
}
